import {RangeSlider} from '../components/rangeSlider';
import {CmsmoduleInit} from '../cmsmodule/cmsmoduleInit';
import {LoginForm} from '../components/loginForm';
import {Share} from '../components/share';
import {ShoelaceLoader} from './shoelaceLoader';

import {Beratung} from '../beratung';
import {Merkliste} from '../merkliste';
import {Dsllistloader} from '../dsl';
import {RememberTarifsSlider} from '../components/rememberTarifsSlider';
import {ShortcodeManger} from '../beratung/shortcodeManger';

declare const Cookiebot: {
    renew: () => void;
};

/**
 * Initialisierung
 * wird als globales window object exportiert, damit es in der /js/cmsmodules.js Datei verwendet werden kann (z.b. nach ReloadModule (Filter setzen))
 */
export class LogitelInit {
    constructor(viewRoot: HTMLElement) {
        new RangeSlider(viewRoot);
        new CmsmoduleInit(viewRoot);
        new LoginForm(viewRoot);
        new RememberTarifsSlider(viewRoot);
        new Share(viewRoot);

        const CookiebotLinks = document.querySelectorAll<HTMLAnchorElement>('.renew-cookies');

        CookiebotLinks.forEach((link) => {
            link.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();

                if (typeof Cookiebot !== 'undefined' && typeof Cookiebot.renew === 'function') {
                    Cookiebot.renew();
                }
            });
        });

        setTimeout(() => {
            new ShortcodeManger();
        }, 1000);

        const loader = new ShoelaceLoader();
        loader.waitForSLReady();

        this.reinitializeOnReload();

        const viewrootList = document.querySelector<HTMLElement>('.cms-module-dsllist');
        if (typeof Dsllistloader === 'function' && viewrootList) {
            new Dsllistloader(viewrootList);
        }

        if (typeof Beratung !== 'undefined') {
            new Beratung(viewRoot);
        } else {
            // never load this from cache
            // there is no nice way of adding a cache buster to the import statement at this moment.
            // Once we refactored this file to a ts class, we can remove this workaround
            // for shortcode
            const timestamp = new Date().getTime();
            import(`../js_ts/beratung.js?version=${timestamp}`).then(({Beratung}) => {
                new Beratung(viewRoot);
            });
        }
        if (typeof Merkliste !== 'undefined') {
            new Merkliste(viewRoot);
        } else {
            // never load this from cache
            // there is no nice way of adding a cache buster to the import statement at this moment.
            // Once we refactored this file to a ts class, we can remove this workaround
            // for shortcode
            const timestamp = new Date().getTime();
            import(`../js_ts/merkliste.js?version=${timestamp}`).then(({Merkliste}) => {
                new Merkliste(viewRoot);
            });
        }
    }

    /**
     * @see reloadManager.ts:reloadModule
     */
    private reinitializeOnReload() {
        document.addEventListener(
            'clxReloadModules',
            ((event: CustomEvent) => {
                new LogitelInit(event.detail.viewRoot);
            }) as EventListener, // workaround for custom events
            {once: true},
        );
    }
}
